import request from '@/utils/request'

const houseTypeApi = {
  listByCode: '/api/residentialHouseType/listByCode'
}

const houseApi = {
  listByType: '/api/residential/houseListByType'
}

export function getHouseType (params) {
  return request({
    url: houseTypeApi.listByCode,
    method: 'get',
    params: params
  })
}

export function getHouseListByType (params) {
  return request({
    url: houseApi.listByType,
    method: 'post',
    data: params
  })
}